/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

/**
 * Retrieves the social service's icon component and label.
 *
 * @param {Object} variation The object of the social service variation.
 * @return {Object} An object containing the Icon component for social service and label.
 */
export function getSocialService( variation ) {
	const ChainIcon = () => {
		return <span className="portal-lucide-icon" dangerouslySetInnerHTML={ { __html: window.portal_lucide_icons.Box.rendered } } />;
	};

	if ( ! variation?.name ) {
		return {
			icon: ChainIcon,
			label: __( 'Social Icon', 'suredash' ),
		};
	}

	return {
		icon: variation?.icon ?? ChainIcon,
		label: variation?.title ?? __( 'Social Icon', 'suredash' ),
	};
}
